import { render, staticRenderFns } from "./InboundContainers.vue?vue&type=template&id=8627911c&scoped=true&"
import script from "./InboundContainers.vue?vue&type=script&lang=js&"
export * from "./InboundContainers.vue?vue&type=script&lang=js&"
import style0 from "./InboundContainers.vue?vue&type=style&index=0&id=8627911c&scoped=true&lang=css&"
import style1 from "./InboundContainers.vue?vue&type=style&index=1&id=8627911c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8627911c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VList,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
